// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__28WDB","productName":"Table_productName__3Ki9d"};